import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotMarker, CreateSnapshotMarkerDto } from 'types';

export const createMarker = ({
  data,
  snapshotId,
}: {
  data: CreateSnapshotMarkerDto;
  snapshotId: number;
}): Promise<SnapshotMarker> => {
  return axios.post(`/api/snapshots/${snapshotId}/markers`, data);
};

type UseCreateMarkerOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof createMarker>;
};

export const useCreateMarker = ({
  config,
  snapshotId,
}: UseCreateMarkerOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousMarkers) {
        queryClient.setQueryData(
          ['snapshot', snapshotId, 'markers'],
          context.previousMarkers
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId, 'markers']);
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: createMarker,
  });
};
